export default {
    columns: [
        ///////////////////////////////////////////////////////////////////
        // COMPANY INFO
        ///////////////////////////////////////////////////////////////////
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.partner_customer_employee.company-id.description",//"Código interno empresa",
          label: "wkt.admin.qbuilder.model.partner_customer_employee.company-id.text",//"Código empresa",
          field: "companyId"
        },
        {

          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.partner_customer_employee.company-cif.description",//"CIF empresa",
          label: "wkt.admin.qbuilder.model.partner_customer_employee.company-cif.text",//"CIF empresa",
          field: "companyCif"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.partner_customer_employee.company-name.description",//"Nombre empresa",
          label: "wkt.admin.qbuilder.model.partner_customer_employee.company-name.text",//"Nombre empresa",
          field: "companyName"
        },
        ///////////////////////////////////////////////////////////////////
        // EMPLOYEE INFO
        ///////////////////////////////////////////////////////////////////
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.id.description",//"Código interno",
          label: "wkt.admin.qbuilder.model.employee.id.text",//"Código",
          field: "id"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.firstname.description",//"Nombre",
          label: "wkt.admin.qbuilder.model.employee.firstname.text",//"Nombre",
          field: "firstname"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.lastname.description",//"Apellidos",
          label: "wkt.admin.qbuilder.model.employee.lastname.text",//"Apellidos",
          field: "lastname"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.id-number.description",//"Documento identificativo",
          label: "wkt.admin.qbuilder.model.employee.id-number.text",//"Documento ID",
          field: "idNumber"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.external-id.description",//"Referencia externa",
          label: "wkt.admin.qbuilder.model.employee.external-id.text",//"Referencia",
          field: "externalId"
        },
        {
          field: "username",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.username.description",//"Nombre de usuario",
          label: "wkt.admin.qbuilder.model.employee.username.text",//"Usuario"
        },
        {
          field: "creationDate",
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.employee.creation-date.description",//"Fecha de creación",
          label: "wkt.admin.qbuilder.model.employee.creation-date.text",//"F. Creación",
          formatter: 'formatDateTime'
        },
        {
          field: "lastAccess",
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.employee.last-access.description",//"Fecha de último acceso",
          label: "wkt.admin.qbuilder.model.employee.last-access.text",//"Último acceso",
          formatter: 'formatDateTime'
        },
        {
          field: "birthday",
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.employee.birthday.description",//"Fecha de nacimiento",
          label: "wkt.admin.qbuilder.model.employee.birthday.text",//"F. Nacimiento",
          formatter: 'formatSimpleDate'
        },
        {
          field: "workplaceId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.workplace-id.description",//"Código del centro de trabajo",
          label: "wkt.admin.qbuilder.model.employee.workplace-id.text",//"Código centro trabajo"
        },
        {
          field: "workplaceName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.workplace-name.description",//"Nombre Centro de trabajo",
          label: "wkt.admin.qbuilder.model.employee.workplace-name.text",//"Centro trabajo"
        },
        {
          field: "departmentId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.department-id.description",//"Código del departamento",
          label: "wkt.admin.qbuilder.model.employee.department-id.text",//"Código departamento"
        },
        {
          field: "departmentName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.department-name.description",//"Nombre Departamento",
          label: "wkt.admin.qbuilder.model.employee.department-name.text",//"Departamento"
        },
        {
          field: "legalEntityName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.legal-entity-name.description",
          label: "wkt.admin.qbuilder.model.employee.legal-entity-name.text"
        },
        {
          field: "legalEntityTaxId",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.legal-entity-tax-id.description",
          label: "wkt.admin.qbuilder.model.employee.legal-entity-tax-id.text"
        },
        {
          field: "currentVacationDays",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.current-vacation-days.description",//"Días de vacaciones pendientes",
          label: "wkt.admin.qbuilder.model.employee.current-vacation-days.text",//"Días vacaciones"
        },
        {
          field: "currentExtraDays",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.current-extra-days.description",//"Días extra pendientes",
          label: "wkt.admin.qbuilder.model.employee.current-extra-days.text",//"Días extra"
        },
        {
          field: "supervisorId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.supervisor-id.description",//"ID Supervisor",
          label: "wkt.admin.qbuilder.model.employee.supervisor-id.text",//"ID Supervisor"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.supervisor-firstname.description",//"Nombre",
          label: "wkt.admin.qbuilder.model.employee.supervisor-firstname.text",//"Nombre",
          field: "supervisorFirstname"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.supervisor-lastname.description",//"Apellidos",
          label: "wkt.admin.qbuilder.model.employee.supervisor-lastname.text",//"Apellidos",
          field: "supervisorLastname"
        },
        {
          field: "mobileNumberPrefix",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.mobile-number-prefix.description",//"Prefijo teléfnono móvil",
          label: "wkt.admin.qbuilder.model.employee.mobile-number-prefix.text",//"Prefijo móvil"
        },
        {
          field: "mobileNumber",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.mobile-number.description",//"Teléfnono móvil",
          label: "wkt.admin.qbuilder.model.employee.mobile-number.text",//"Móvil"
        },
        {
          field: "accountNumber",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.account-number.description",//"Número de cuenta bancaria",
          label: "wkt.admin.qbuilder.model.employee.account-number.text",// "CCC"
        },
        {
          field: "canClient",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.can_client.description",    //"Acceso área de trabajador",
          label: "wkt.admin.qbuilder.model.employee.can_client.text",  //"Acceso área de trabajador",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          field: "position",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.position.description",//"Puesto",
          label: "wkt.admin.qbuilder.model.employee.position.text",//"Puesto"
        },
        {
          field: "costCenter",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.cost-center.description",//"Centro de coste",
          label: "wkt.admin.qbuilder.model.employee.cost-center.text",//"Centro de coste"
        },
        {
          field: "calendarId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.calendar-id.description",    //"ID calendario",
          label: "wkt.admin.qbuilder.model.employee.calendar-id.text",  //"ID calendario"
        },
        {
          field: "calendarName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.calendar-name.description",  //"calendario",
          label: "wkt.admin.qbuilder.model.employee.calendar-name.text",    //"calendario"
        },
        {
          field: "vacationPolicyId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.vacation-policy-id.description", //"ID Politica de vacaciones",
          label: "wkt.admin.qbuilder.model.employee.vacation-policy-id.text",   //"ID Politica de vacaciones"
        },
        {
          field: "vacationPolicyName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.vacation-policy-name.description",   //"Politica de vacaciones",
          label: "wkt.admin.qbuilder.model.employee.vacation-policy-name.text", //"Politica de vacaciones"
        },
        {
          field: "canTelework",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.can-telework.description",   //"Permitir teletrabajo",
          label: "wkt.admin.qbuilder.model.employee.can-telework.text", //"Permitir teletrabajo",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          field: "mustCheckin",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.must-checkin.description",   //"Debe realizar check-in",
          label: "wkt.admin.qbuilder.model.employee.must-checkin.text", //"Debe realizar check-in",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          field: "isAdmin",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.is-admin.description",   //"Administrador",
          label: "wkt.admin.qbuilder.model.employee.is-admin.text", //"Administrador",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          field: "phoneNumber",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.phone-number.description",   //"Teléfono directo",
          label: "wkt.admin.qbuilder.model.employee.phone-number.text", //"Teléfono directo"
        },
        {
          field: "dateRegistrationCompany",
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.employee.date-registration-company.description",  //"Fecha inicio contrato",
          label: "wkt.admin.qbuilder.model.employee.date-registration-company.text",    //"Fecha inicio contrato",
          formatter: 'formatDateTime'
        },
        {
          field: "dateDismissalCompany",
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.employee.date-dismissal-company.description", //"Fecha fin contrato",
          label: "wkt.admin.qbuilder.model.employee.date-dismissal-company.text",   //"Fecha fin contrato",
          formatter: 'formatDateTime'
        },
       {
          field: "contractType",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.contract-type.description",  //"Tipo de contrato",
          label: "wkt.admin.qbuilder.model.employee.contract-type.text",    //"Tipo de contrato"
        },
       {
          field: "typeOfJorney",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.type-of-jorney.description", //"Tipo de jornada",
          label: "wkt.admin.qbuilder.model.employee.type-of-jorney.text",   //"Tipo de jornada"
        },
        {
          field: "definedSchelude",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.defined-schelude.description",   //"Horario definido",
          label: "wkt.admin.qbuilder.model.employee.defined-schelude.text", //"Horario definido"
        },
        {
          field: "jobCategory",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.job-category.description",   //"Categoría profesional",
          label: "wkt.admin.qbuilder.model.employee.job-category.text", //"Categoría profesional"
        },
        {
          field: "weeklyWorkHours",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.weekly-work-hours.description",  //"Horas trabajo semanales",
          label: "wkt.admin.qbuilder.model.employee.weekly-work-hours.text",    //"Horas trabajo semanales"
        },
        {
          field: "additionalHoursCategoryName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.additional-hours-type-name.description",   //"Tipo de hora adicional",
          label: "wkt.admin.qbuilder.model.employee.additional-hours-type-name.text", //"Tipo de hora adicional"
        },
        {
          field: "groupMode",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.group-mode.description",     //"Método de agrupación de trabajadores",
          label: "wkt.admin.qbuilder.model.employee.group-mode.text",   //"Método de agrupación de trabajadores",
          formatter: 'formatChoice',
          choices: [ { 'key':'-1', 'value': 'wkt.admin.qbuilder.model.employee.group-mode.option.not_set' /*'Valor por defecto para la empresa'*/ },
                     { 'key':'0', 'value': 'wkt.admin.qbuilder.model.employee.group-mode.option.none' /*'Deshabilitar agrupaciones'*/ },
                     { 'key':'1', 'value': 'wkt.admin.qbuilder.model.employee.group-mode.option.whole_company' /*'Toda la empresa'*/ },
                     { 'key':'2', 'value': 'wkt.admin.qbuilder.model.employee.group-mode.option.same_workplace' /*'Mismo centro de trabajo'*/ },
                     { 'key':'3', 'value': 'wkt.admin.qbuilder.model.employee.group-mode.option.same_department' /*'Mismo departamento'*/ },
                     { 'key':'4', 'value': 'wkt.admin.qbuilder.model.employee.group-mode.option.same_workplaceand_department' /*'Mismo departamento y centro de trabajo'*/ },
                     { 'key':'5', 'value': 'wkt.admin.qbuilder.model.employee.group-mode.option.same_supervisor' /*'Mismo responsable'*/ },
                     { 'key':'6', 'value': 'wkt.admin.qbuilder.model.employee.group-mode.option.same_legal_entity' /*'Misma entidad legal'*/ } ]
        },
        {
          field: "sendMessagePermission",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.send-message-permission.description",    //"Permiso para el envío de mensajes",
          label: "wkt.admin.qbuilder.model.employee.send-message-permission.text",  //"Permiso para el envío de mensajes",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value': 'wkt.admin.qbuilder.model.employee.send-message-permission.option.none' /*'Sin permiso'*/ },
                     { 'key':'1', 'value': 'wkt.admin.qbuilder.model.employee.send-message-permission.option.all' /*'A todos'*/ },
                     { 'key':'2', 'value': 'wkt.admin.qbuilder.model.employee.send-message-permission.option.same_group' /*'Al mismo grupo'*/ } ]
        },
        {
          field: "isEnabled",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.employee.enabled.description",    //"Habilitado",
          label: "wkt.admin.qbuilder.model.employee.enabled.text",  //"Habilitado",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          field: "internalNotes",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.employee.internal_notes.description",//"Observaciones",
          label: "wkt.admin.qbuilder.model.employee.internal_notes.text",//"Observaciones"
        }
     ],
}
